<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
></app-table-header>
<nz-table appColumnLayout id="order-change-log-list-table"
  #tableRef
  nzShowSizeChanger
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  >
  <thead>
    <tr>
      <th nzColumnKey="createdAt" [nzSortFn]="true">Datum</th>
      <th nzColumnKey="user.fullName" [nzSortFn]="true">Benutzer</th>
      <th nzColumnKey="fieldName" [nzSortFn]="true">Feld / Aktion</th>
      <th nzColumnKey="change">Änderung</th>
      <th nzColumnKey="entityLabel" [nzSortFn]="true">Bezug</th>
    </tr>
  </thead>
  <tbody>
    @for (log of data.results; track log.id) {
      <tr>
        <td>{{ log.createdAt | dateFormat }}</td>
        <td>{{ log.user?.fullName || 'System' }}</td>
        <td>{{ log.fieldName }}</td>
        <td>{{ formatChange(log) }}</td>
        <td>{{ log.entityLabel || '—' }}</td>
      </tr>
    }
  </tbody>
</nz-table>
